import RichTextTranslator from "../../Logic/RichTextTranslator";
import debounce from "lodash.debounce";

import { CompleteEditor } from "../Molecule/MinimalEditor";
import { ElementType, TextElement } from "types/types";
import { JSONContent } from "@tiptap/react";
import { ChangeEvent } from "react";

/*
  @function TermEditor
  edit term
  @param text {object} - handles text information
  @param onUpdateStrings {function} - update simple strings
  @param onUpdatdateRichtText {function} - update rich text
*/
export default function TermEditor({
  text,
  onUpdateStrings,
  onUpdateRichText,
}: {
  text?: { name: string; description?: TextElement; term_id?: string };
  onUpdateStrings: (
    v: ChangeEvent<HTMLInputElement>,
    key: string,
    type: string,
    id: string
  ) => void;
  onUpdateRichText: (
    v: JSONContent,
    key: string,
    type: string,
    id: string
  ) => void;
}) {
  const description =
    text?.description && typeof text.description === "string"
      ? JSON.parse(text.description)
      : text?.description !== undefined
      ? text.description
      : {};

  return (
    <>
      <label className="text-center m-2">Name</label>
      <input
        type="text"
        id="first"
        name="first"
        defaultValue={text?.name ? text.name : ""}
        className="border border-2 border-black m-6"
        onChange={debounce(
          (o: ChangeEvent<HTMLInputElement>) =>
            onUpdateStrings(
              o,
              "name",
              ElementType.Term,
              text?.term_id !== undefined ? text.term_id : ""
            ),
          200
        )}
      />
      <label className="text-center m-2">Term Description</label>
      <CompleteEditor
        className="border border-2 border-black m-6 h-full"
        onUpdate={(v: JSONContent) =>
          onUpdateRichText(
            v,
            "description",
            ElementType.Term,
            text?.term_id !== undefined ? text.term_id : ""
          )
        }
        text={
          "text" in description
            ? {
                type: "doc",
                content: RichTextTranslator({ text: description.text }),
              }
            : description
        }
        elementAskingRerender={[]}
        element={{ term: text?.term_id }}
      />
    </>
  );
}
